export const DeviceTypes = {
  NotSet: 0,
  CardioAssistant: 1,
  Plaster: 2
};

export const EcgBranchTypes = {
  NotSet: { value: 0, label: 'Not Set' },
  I: { value: 1, label: 'I' },
  II: { value: 2, label: 'II' },
  III: { value: 3, label: 'III' },
  aVR: { value: 4, label: 'aVR' },
  aVL: { value: 5, label: 'aVL' },
  aVF: { value: 6, label: 'aVF' },
  V1: { value: 7, label: 'V1' },
  V2: { value: 8, label: 'V2' },
  V3: { value: 9, label: 'V3' },
  V4: { value: 10, label: 'V4' },
  V5: { value: 11, label: 'V5' },
  V6: { value: 12, label: 'V6' },
  RC4: { value: 13, label: 'RC4' },
  DS: { value: 14, label: 'DS' },
  C5S: { value: 15, label: 'C5S' },
  TEST: { value: 16, label: 'TEST' },
  A: { value: 101, label: 'A' },
  B: { value: 102, label: 'B' }
};

// Get available branches based on device type
export const getAvailableBranches = (deviceTypeId) => {
  if (deviceTypeId === DeviceTypes.Plaster) {
    // Only A and B for CardioAssistant
    return [EcgBranchTypes.A, EcgBranchTypes.B];
  } else {
    // For NotSet and Plaster: I, II, III, and C5S
    return [
      EcgBranchTypes.I,
      EcgBranchTypes.II,
      EcgBranchTypes.III,
      EcgBranchTypes.aVR,
      EcgBranchTypes.aVL,
      EcgBranchTypes.aVF,
      EcgBranchTypes.V1,
      EcgBranchTypes.V2,
      EcgBranchTypes.V3,
      EcgBranchTypes.V4,
      EcgBranchTypes.V5,
      EcgBranchTypes.V6,
      EcgBranchTypes.RC4,
      EcgBranchTypes.DS,
      EcgBranchTypes.C5S
    ];
  }
};